import {createSelector} from 'reselect'

//Simple Selectors (private)
const currentUserSelector = state => state.auth && state.auth.user
const loginErrorSelector = state => state.auth && state.auth.error
const additionalFieldsSelector = state =>
  state.auth &&
  state.auth.user &&
  state.auth.user.challengeParam &&
  state.auth.user.challengeParam.requiredAttributes
const challengeSelector = state =>
  state.auth && state.auth.user && state.auth.user.challengeName;
const resetPasswordErrorSelector = state => state.auth && state.auth.forgotPasswordError;
const forgotPasswordConfirm = state => state.auth && state.auth.forgotPasswordConfirm;
const createUserConfirm = state => state.auth && state.auth.createUserConfirm;
const forgotPasswordByEmail = state => state.auth && state.auth.forgotPasswordByEmail;
const supportProposal = state => state.auth && state.auth.supportProposal;
const createRetailer = state => state.auth && state.auth.createRetailer;
const isCreateAccountFulfilled = state =>
  state.auth && state.auth.isCreateAccountFulfilled;
const isLoading = state => state.auth && state.auth.isLoading;
const establishmentNameSelector = state =>
  state.auth && state.auth.queryParams && state.auth.queryParams.est;
const inviteLinkSelector = state =>
  state.auth && state.auth.queryParams && state.auth.queryParams.invite_link;
const currentUserFirstName = state => state.auth && state.auth.user_first_name;
const currentUserLastName = state => state.auth && state.auth.user_last_name;
const resetPasswordRequired = state => state.auth && state.auth.resetPasswordRequired;
const resetPasswordByEmail = state => state.auth && state.auth.resetPasswordByEmail;
const globalLoading = state => state.auth && state.auth.globalLoading;
const errorMessage = state => state.auth && state.auth.errorMessage;
const phoneError = state => state.auth && state.auth.phoneError;
const emailError = state => state.auth && state.auth.emailError;

//Selectors to be used in components (public)
export const selectCurrentUser = createSelector(
  [currentUserSelector],
  currentUser => {
    return currentUser || {}
  }
)

export const selectCurrentUserFirstName = createSelector(
  [currentUserFirstName],
  currentUserFirstName => {
    return currentUserFirstName || null
  }
)

export const selectCurrentUserLastName = createSelector(
  [currentUserLastName],
  currentUserLastName => {
    return currentUserLastName || null
  }
)

export const selectResetPasswordByEmail = createSelector(
  [resetPasswordByEmail], resetPasswordByEmail => {
    return resetPasswordByEmail || false;
  }
)

export const selectEstablishmentName = createSelector(
  [establishmentNameSelector],
  establishmentName => {
    return establishmentName
  }
)

export const selectHasInviteLink = createSelector(
  [inviteLinkSelector],
  inviteLink => {
    return !!inviteLink
  }
)

export const selectCurrentUserUsername = createSelector(
  [currentUserSelector],
  currentUser => {
    return currentUser && currentUser.email
  }
)

export const selectLoginError = createSelector(
  [loginErrorSelector],
  error => {
    return error || ''
  }
)

export const selectAdditionalVerificationFields = createSelector(
  [additionalFieldsSelector],
  fields => {
    return fields || []
  }
)

export const selectChallengeName = createSelector(
  [challengeSelector],
  challengeName => {
    return challengeName || null
  }
)

export const selectResetPasswordError = createSelector(
  [resetPasswordErrorSelector],
  forgotPasswordError => {
    return forgotPasswordError || ''
  }
)

export const selectForgotPasswordConfirm = createSelector(
  [forgotPasswordConfirm],
  forgotPasswordConfirm => {
    return forgotPasswordConfirm || false
  }
)

export const selectCreateUserConfirm = createSelector(
  [createUserConfirm],
  createUserConfirm => {
    return createUserConfirm || null
  }
)

export const selectForgotPasswordByEmail = createSelector(
  [forgotPasswordByEmail],
  forgotPasswordByEmail => {
    return forgotPasswordByEmail || false
  }
)

export const selectSupportProposal = createSelector(
  [supportProposal],
  supportProposal => {
    return supportProposal || false
  }
)

export const selectCreateRetailer = createSelector(
  [createRetailer],
  createRetailer => {
    return createRetailer || false
  }
)

export const selectIsCreateAccountFulfilled = createSelector(
  [isCreateAccountFulfilled],
  isCreateAccountFulfilled => {
    return isCreateAccountFulfilled || false
  }
)

export const selectIsLoading = createSelector(
  [isLoading],
  isLoading => {
    return isLoading || false
  }
)

export const selectResetPasswordRequired = createSelector(
  [resetPasswordRequired],
  resetPasswordRequired => {
    return resetPasswordRequired || false
  }
)

export const selectGlobalLoading = createSelector(
[globalLoading],
    globalLoading => globalLoading || false
)

export const selectErrorMessage = createSelector(
  [errorMessage],
  errorMessage => errorMessage || null
)

export const selectPhoneError = createSelector(
  [phoneError],
  phoneError => phoneError || false
)

export const selectEmailError = createSelector(
  [emailError],
  emailError => emailError || false
)
